import React from "react";
import {
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaLinkedinIn,
  FaEnvelope,
  FaPhoneAlt,
  FaMapMarkerAlt,
} from "react-icons/fa";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-tr from-gray-900 via-black to-gray-900 text-white py-16 px-6 sm:px-12">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
        
        {/* Brand/About */}
        <div className="space-y-4">
          <h3 className="text-2xl font-black tracking-tighter text-white">
            MOUNI<span className="text-[#a300ff]"> IT SERVICES</span>
          </h3>
          <p className="text-sm text-gray-400 leading-relaxed">
            Empowering professionals through industry-leading training. Master cloud computing, cybersecurity, and full-stack development with expert-led courses.
          </p>
          <div className="flex gap-4 pt-2">
            {[
              { icon: <FaFacebookF />, color: "hover:bg-blue-600" },
              { icon: <FaTwitter />, color: "hover:bg-blue-400" },
              { icon: <FaInstagram />, color: "hover:bg-pink-500" },
              { icon: <FaLinkedinIn />, color: "hover:bg-blue-700" },
            ].map((social, idx) => (
              <a
                key={idx}
                href="#"
                className={`w-9 h-9 flex items-center justify-center bg-gray-800 rounded-lg transition-all duration-300 ${social.color}`}
              >
                {social.icon}
              </a>
            ))}
          </div>
        </div>

        {/* Quick Links */}
        <div>
          <h3 className="text-lg font-bold mb-6 border-b border-purple-500/30 pb-2 inline-block">
            Quick Links
          </h3>
          <ul className="space-y-3 text-sm text-gray-400">
            <li><a href="#home" className="hover:text-[#a300ff] transition-colors">Home</a></li>
            <li><a href="#courses" className="hover:text-[#a300ff] transition-colors">Training Programs</a></li>
            <li><a href="#about" className="hover:text-[#a300ff] transition-colors">About Us</a></li>
            <li><a href="#contact" className="hover:text-[#a300ff] transition-colors">Contact Support</a></li>
            <li><a href="#privacy" className="hover:text-[#a300ff] transition-colors">Privacy Policy</a></li>
          </ul>
        </div>

        {/* Office Address */}
        <div>
          <h3 className="text-lg font-bold mb-6 border-b border-purple-500/30 pb-2 inline-block">
            Our Office
          </h3>
          <div className="space-y-4">
            <div className="flex gap-3">
              <FaMapMarkerAlt className="text-[#a300ff] mt-1 shrink-0" />
              <p className="text-sm text-gray-400 leading-relaxed">
                1776 Peachtree St NW #200N,<br />
                Atlanta, GA 30309,<br />
                United States
              </p>
            </div>
          </div>
        </div>

        {/* Contact Info */}
        <div>
          <h3 className="text-lg font-bold mb-6 border-b border-purple-500/30 pb-2 inline-block">
            Contact Info
          </h3>
          <div className="space-y-4">
            <div className="flex items-center gap-3 text-sm text-gray-300">
              <FaEnvelope className="text-[#a300ff]" />
              <span className="hover:text-white transition-colors cursor-pointer">support@mouni-it.com</span>
            </div>
            <div className="flex items-center gap-3 text-sm text-gray-300">
              <FaPhoneAlt className="text-[#a300ff]" />
              <span className="hover:text-white transition-colors cursor-pointer">+1 (404) 2392-163</span>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="mt-16 border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
        <p className="text-xs text-gray-500 text-center md:text-left">
          © {currentYear} Mouni IT Services. All rights reserved.
        </p>
        <div className="flex gap-6 text-xs text-gray-500">
          <a href="#" className="hover:text-white transition-colors">Terms of Service</a>
          <a href="#" className="hover:text-white transition-colors">Cookie Policy</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;